import * as React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Dashboard from "./components/DashBoard/Dashboard";
import { RequireAuth } from "./components/requiredAuth";
import RebrandingPopUp from "./components/RebrandingPopUp/rebrandingPopup";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import TagManager from "react-gtm-module";
import ResponseHandle from "./components/ResponseHandle/ResponseHandle";
import AuthStoreWithSSO from "./components/SsoAuth/sso";
import ConsoleLogger from "./services/otel/consoleLogger";
import { InitOtel } from "./services/otel/init";
import TraceProvider from "./services/otel/instrumentation";
import ExternalRedirect from "./redirection";

// ... (rest of your interfaces and GTM setup)
interface TagManagerArgs {
  gtmId: string;
  // Add any other properties that are needed
}

interface CustomEventProperties {
  [key: string]: any; // Adjust this type according to the actual structure
}

interface GtmPusherObject {
  event: string;
  customEventProperties?: CustomEventProperties;
}

const tagManagerArgs = {
  gtmId: "GTM-MGFDNPZQ",
};


declare global {
  interface Window {
    GtmPusher: (ob: GtmPusherObject) => void;
    tvWidget: {
      showNoticeDialog: (options: {
        title: string;
        body: string;
        callback: () => void;
      }) => void;
      showConfirmDialog: (options: {
        title: string;
        body: string;
        callback: (param: boolean) => void;
      }) => void;
    };
  }
}

TagManager.initialize(tagManagerArgs);
(window as any).GtmPusher = function (ob: GtmPusherObject) {
  if (ob.customEventProperties === undefined) {
    ob.customEventProperties = {};
    if ((window as any).google_tag_manager !== undefined) {
      (window as any).google_tag_manager["GTM-MGFDNPZQ"].dataLayer.set(
        "customEventProperties",
        undefined
      );
    }
  }
  (window as any).dataLayer.push(ob);
};


const App: React.FC = () => {
  console.log("App Rendered", "version: ", process.env.REACT_APP_COMMIT_VERSION);
  InitOtel({
    env: process.env.REACT_APP_ENV || "dev",
    name: "tv-terminal",
    version: `${process.env.REACT_APP_COMMIT_VERSION}`,
  });

  return (
    <div id="themeManage">
      <TraceProvider>
        <ConsoleLogger />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick={true}
          rtl={false}
          pauseOnHover={true}
        />
        <RebrandingPopUp />
        <BrowserRouter>
          <Routes>
            {/* SSO Authentication route replaces authStore */}
            <Route path="/tvTerminal/sso" element={<AuthStoreWithSSO />} />

            {/* Default route */}
            {/* <Route path="/" element={<LoginForm />} /> */}


            {/* Protected routes */}
            <Route element={<RequireAuth />}>
              <Route path="/tvTerminal" element={<Dashboard />} />
            </Route>


            {/* 404 handler */}
            <Route path="*" element={<ExternalRedirect />} />
            <Route element={<ResponseHandle />} />
          </Routes>
        </BrowserRouter>
      </TraceProvider>
    </div>
  );
};

export default App;